import React, { Fragment, useState, useEffect, useRef } from "react";
import { Redirect } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import loading from "../components/loading.json";
import { themeStyle, themeStyleDark } from "../components/Components";
import { gsap } from "gsap";
import Backdrop from "@mui/material/Backdrop";
import bg from "../bg.mp4";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Grid } from "@mui/material";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import VisitUs from "../components/VisitUs";

export default function About() {
  const state = useSelector((state) => state);

  useEffect(() => {}, []);

  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div className="overlay"></div>

        <div
          className="abouthero"
          style={{
            background:
              "linear-gradient(0deg, rgba(2, 77, 194, 0.2), rgba(2, 77, 194, 0.2)), url('" +
              require("../img/AGIS (7).jpeg") +
              "')",
          }}
        >
          <div
            style={{
              fontSize: state.auth.isMobile ? "30px" : "30px",
              fontWeight: "bold",
              fontFamily: "Montserrat",
              textAlign: "left",
              color:
                state.auth.theme == "dark"
                  ? themeStyleDark.primaryButtonTextColor
                  : themeStyle.primaryButtonTextColor,
            }}
          >
            About ASPIRE Grove International Pre-School, Devanahalli Premium
            International Pre-School
          </div>
        </div>
        <div className="aboutabout" style={{ marginTop: "100px" }}>
          <div
            style={{
              fontSize: state.auth.isMobile ? "18px" : "25px",
              fontFamily: "Montserrat",
              textAlign: "justify",
            }}
          >
            <b>
              {" "}
              Welcome to ASPIRE Grove International Pre-School, Devanahalli
              Premium International Pre-School{" "}
            </b>{" "}
            <br /> <br /> 1. A child's first steps into learning begin in a safe
            and nurturing environment. Our preschool is a peaceful haven, away
            from the hustle and bustle, featuring colorful, child-friendly
            spaces designed for discovery and play. <br /> <br /> 2. Our
            classrooms are vibrant hubs of imagination. We provide cozy,
            sensory-rich spaces equipped with age-appropriate learning tools
            that make every day an exciting adventure for little explorers.{" "}
            <br /> <br /> 3. We focus on the holistic development of every
            child. Through play-based learning, we nurture curiosity, build
            social confidence, and instill kindness, helping our little ones
            grow into happy and confident individuals. <br /> <br /> 4. Our
            educators are more than just teachers; they are caring mentors.
            Specialized in early childhood development, our team is passionate
            about providing the warmth and guidance every child needs during
            their formative years. <br /> <br /> 5. Every activity is a chance
            to learn and grow. From creative arts to storytelling and outdoor
            play, our curriculum is designed to develop motor skills, encourage
            teamwork, and spark a lifelong love for learning.
          </div>
        </div>
        <div className="aboutabout2" style={{ marginTop: "-150px" }}>
          <Grid container spacing={5}>
            <Grid item xs={12} md={5}>
              <img
                style={{ width: "100%", objectFit: "cover", margin: "10px" }}
                src={require("../img/chair.png")}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={7} xl={7}>
              <div
                style={{
                  fontSize: "32px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                Chairman's Message
              </div>
              <br />
              <div
                style={{
                  fontSize: state.auth.isMobile ? "18px" : "22px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                An ideal school is one which focuses on bringing out the best in
                every child. It aims at making their students competent
                learners. Every institution functions with a set of principles,
                following traditions and values.
                <br /> <br />
                We at AGIS provide a holistic approach to the entire learning
                process. We encourage our students to be responsible and be role
                models in their thoughts, deeds, approach and attitude.
                <br /> <br />
                At AGIS, we ensure a safe, nurturing and positive learning
                environment. I would like to stress on our mission statement of
                grooming young minds and hearts as Leaders of a nation and hope
                of the future.
                <br /> <br />
                We should strive to prepare our children not merely for economic
                independence and prosperity but also to face life’s challenges
                with confidence and happiness. I’m confident that the days spent
                at AGIS will help our students achieve real success in life.
              </div>
            </Grid>
          </Grid>
        </div>

        <div className="aboutabout2" style={{ marginTop: "-150px" }}>
          <Grid container spacing={5}>
            <Grid item xs={12} sm={12} md={12} lg={7} xl={7}>
              <div
                style={{
                  fontSize: "32px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                Message From Principal
              </div>
              <br />
              <div
                style={{
                  fontSize: state.auth.isMobile ? "18px" : "22px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                As I walk down the hallways of school every day, I can hear
                chatter of eager minds, the shout of excitement from victorious
                athletes , the triumph of the dancing feet and the sound of
                melodious voices harmonizing.
                <br /> <br />
                Education is not preparation for life; Education is life itself.
                Education is right, not a privilege. Yet 61 million children are
                deprived of this right. Educating children no matter where they
                are, is one of the biggest steps we can take towards ending
                extreme poverty.
                <br /> <br />
                I believe there are two types of education. One which teaches us
                how to make a living and the other how to live. In both of these
                types, we prefer to make the best even better.
                <br /> <br />
                Your dreams are our goals. We strive to be better each day for
                your children and their overall development. Gandhiji’s craft
                centric vision is our mission. We aim to make our students
                sharper, stronger and fitter to the changing world.
                <br /> <br />
                We assure you to make our students rich with knowledge and
                wisdom.
                <br /> <br />
                We ensure that with blessings of “God Saraswathi”, encouragement
                from the school management, support from parents, commitment of
                the staff and the efforts of students our school will reach
                greater heights. We will keep our heads high and work towards
                the better results with conviction and courage.
                <br /> <br />
                <b>Mr. Joby Varghese</b> <br />
                MA (Eng), (Socio), MEd, BEd in (Eng), BEd (SPL), RCI <br />
                Principal <br />
                Aspire Grove International School, Vijayapura
                <br />
                <br />
              </div>
            </Grid>
            <Grid item xs={12} md={5}>
              <img
                style={{ width: "100%", objectFit: "cover", margin: "10px" }}
                src={"https://agis.in/assets/images/profile.png"}
              />
            </Grid>
          </Grid>
        </div>
        <div className="news">
          <div
            style={{
              textAlign: "justify",
              marginBottom: "50px",
              marginTop: "50px",
              fontSize: state.auth.isMobile ? "30px" : "30px",
              fontWeight: "bold",
              fontFamily: "Montserrat",
              color:
                state.auth.theme == "dark"
                  ? themeStyleDark.primaryColor
                  : themeStyle.primaryColor,
            }}
          >
            A Glimpse of the Campus
          </div>
          <Grid container spacing={2.5}>
            <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
              <div className="icard">
                <img
                  src={require("../img/AGIS (1).jpeg")}
                  alt="Norway"
                  style={{
                    width: "300px",
                    height: "250px",
                    borderRadius: "10px",
                    objectFit: "contain",
                  }}
                />
                <div
                  style={{
                    padding: "0px 10px 0px 10px",
                    fontSize: "20px",
                    color:
                      state.auth.theme == "dark"
                        ? themeStyleDark.primaryColor
                        : themeStyle.primaryColor,
                    fontFamily: "Montserrat",
                    textAlign: "justify",
                    fontWeight: 600,
                  }}
                ></div>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
              <div className="icard">
                <img
                  src={require("../img/AGIS (7).jpeg")}
                  alt="Norway"
                  style={{
                    width: "300px",
                    height: "250px",
                    borderRadius: "10px",
                    objectFit: "contain",
                  }}
                />
                <div
                  style={{
                    padding: "0px 10px 0px 10px",
                    fontSize: "20px",
                    color:
                      state.auth.theme == "dark"
                        ? themeStyleDark.primaryColor
                        : themeStyle.primaryColor,
                    fontFamily: "Montserrat",
                    textAlign: "justify",
                    fontWeight: 600,
                  }}
                ></div>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
              <div className="icard">
                <img
                  src={require("../img/AGIS (4).jpeg")}
                  alt="Norway"
                  style={{
                    width: "300px",
                    height: "250px",
                    borderRadius: "10px",
                    objectFit: "contain",
                  }}
                />
                <div
                  style={{
                    padding: "0px 10px 0px 10px",
                    fontSize: "20px",
                    color:
                      state.auth.theme == "dark"
                        ? themeStyleDark.primaryColor
                        : themeStyle.primaryColor,
                    fontFamily: "Montserrat",
                    textAlign: "justify",
                    fontWeight: 600,
                  }}
                ></div>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
              <div className="icard">
                <img
                  src={require("../img/AGIS (7).jpeg")}
                  alt="Norway"
                  style={{
                    width: "300px",
                    height: "250px",
                    borderRadius: "10px",
                    objectFit: "contain",
                  }}
                />
                <div
                  style={{
                    padding: "0px 10px 0px 10px",
                    fontSize: "20px",
                    color:
                      state.auth.theme == "dark"
                        ? themeStyleDark.primaryColor
                        : themeStyle.primaryColor,
                    fontFamily: "Montserrat",
                    textAlign: "justify",
                    fontWeight: 600,
                  }}
                ></div>
              </div>
            </Grid>
          </Grid>
          <br />
          <br />
          {/* <Grid
            container
            spacing={2.5}
            style={{ justifyContent: "center", paddingBottom: "100px" }}
          >
            <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
              <div className="icard">
                <img
                  src={require("../img/entrance.jpg")}
                  alt="Norway"
                  style={{
                    width: "300px",
                    height: "250px",
                    borderRadius: "10px",
                    objectFit: "contain",
                  }}
                />
                <div
                  style={{
                    padding: "0px 10px 0px 10px",
                    fontSize: "20px",
                    color:
                      state.auth.theme == "dark"
                        ? themeStyleDark.primaryColor
                        : themeStyle.primaryColor,
                    fontFamily: "Montserrat",
                    textAlign: "justify",
                    fontWeight: 600,
                  }}
                >
                  School Entrance
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
              <div className="icard">
                <img
                  src={require("../img/redday.jpeg")}
                  alt="Norway"
                  style={{
                    width: "300px",
                    height: "250px",
                    borderRadius: "10px",
                    objectFit: "contain",
                  }}
                />
                <div
                  style={{
                    padding: "0px 10px 0px 10px",
                    fontSize: "20px",
                    color:
                      state.auth.theme == "dark"
                        ? themeStyleDark.primaryColor
                        : themeStyle.primaryColor,
                    fontFamily: "Montserrat",
                    textAlign: "justify",
                    fontWeight: 600,
                  }}
                >
                  Red day
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
              <div className="icard">
                <img
                  src={require("../img/krshna.jpeg")}
                  alt="Norway"
                  style={{
                    width: "300px",
                    height: "250px",
                    borderRadius: "10px",
                    objectFit: "contain",
                  }}
                />
                <div
                  style={{
                    padding: "0px 10px 0px 10px",
                    fontSize: "20px",
                    color:
                      state.auth.theme == "dark"
                        ? themeStyleDark.primaryColor
                        : themeStyle.primaryColor,
                    fontFamily: "Montserrat",
                    textAlign: "justify",
                    fontWeight: 600,
                  }}
                >
                  Gokulashtami
                </div>
              </div>
            </Grid>
          </Grid> */}
        </div>
        <VisitUs />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
